<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="w-4 h-4 text-dark-accent-secondary">
  <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2" fill="none"/>
  <path stroke-linecap="round" stroke-linejoin="round" d="M9 12l2 2 4-4" />
</svg>
